const AccountType = {
    FullAccess: 1,
    Concurrent: 2,
    Readonly: 3,
}
export default AccountType
